/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Limit configuration for a specific resource type.
*/
export class LimitData {
  'sizeLimit'?: number | null;
  'objectCountLimit'?: number | null;
  'quotaLimit'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sizeLimit",
      "baseName": "sizeLimit",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "objectCountLimit",
      "baseName": "objectCountLimit",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "quotaLimit",
      "baseName": "quotaLimit",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return LimitData.attributeTypeMap;
  }

  public constructor() {
  }
}

